import { ResourceAppModule } from "@/shared/app";
import {
  komponentResource,
  Komponent,
} from "@megarax/client/src/resources/plm";
import { plmApp } from "../app";

export const komponentModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-tint fa-fw",
  title: "Komponenty",
  route: "komponent",
  app: plmApp,
  resource: komponentResource,
  itemConstructor: Komponent,
};
